import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["roomSelect", "seatSelectionContainer", "seatSelectionCheckbox"]
  static values = { seatLayoutRoomIds: Array }

  connect() {
    this.toggleSeatSelection()
  }

  toggleSeatSelection(event) {
    // Check if all required targets exist before proceeding
    if (!this.hasRoomSelectTarget || !this.hasSeatSelectionContainerTarget || !this.hasSeatSelectionCheckboxTarget) {
      return
    }

    const hiddenInput = this.roomSelectTarget.querySelector('input[type="hidden"]')
    const selectedRoomId = event?.detail?.value ?? hiddenInput?.value
    const roomHasSeatLayout = selectedRoomId &&
      this.seatLayoutRoomIdsValue.map(String).includes(String(selectedRoomId))

    if (roomHasSeatLayout) {
      // Room with seat layout selected - show seat selection option
      this.seatSelectionContainerTarget.style.display = 'block'
    } else {
      // No room or room without seat layout - hide and uncheck
      this.seatSelectionContainerTarget.style.display = 'none'
      this.seatSelectionCheckboxTarget.checked = false
    }
  }
}
